import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { LoadScript } from '@react-google-maps/api';

console.error = () => {};
console.warn = () => {};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LoadScript googleMapsApiKey="AIzaSyAqV-NvTVA-spCLUuTRpz2pcBR5z4ICU30" libraries={['places']}>
      <App />
    </LoadScript>
  </React.StrictMode>
);

reportWebVitals();
